import { render, staticRenderFns } from "./VaTab.vue?vue&type=template&id=73e8c83a&"
import script from "./VaTab.vue?vue&type=script&lang=js&"
export * from "./VaTab.vue?vue&type=script&lang=js&"
import style0 from "./VaTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports